/**
 * Defines shared responsive container widths as Mantine-scaled CSS lengths.
 * Assumptions: Consumers provide the Mantine scale variable; these values do not select breakpoints.
 */
export const applicationContainerSizes = {
    xs: "calc(33.75rem * var(--mantine-scale))",
    sm: "calc(45rem * var(--mantine-scale))",
    md: "calc(60rem * var(--mantine-scale))",
    lg: "calc(71.25rem * var(--mantine-scale))",
    xl: "calc(88rem * var(--mantine-scale))"
} as const;
